export const CATEGORIES = [
  { id: "painting", label: "Painting", icon: "\u{1F3A8}", color: "#E8927C" },
  { id: "drywall", label: "Drywall", icon: "\u{1F9F1}", color: "#C4A882" },
  { id: "plumbing", label: "Plumbing", icon: "\u{1F527}", color: "#6B9BD2" },
  { id: "electrical", label: "Electrical", icon: "\u26A1", color: "#F0C75E" },
  { id: "hvac", label: "HVAC", icon: "\u{1F321}\uFE0F", color: "#7ECEC1" },
  { id: "millwork", label: "Millwork", icon: "\u{1FA9A}", color: "#B8956A" },
  { id: "general", label: "General", icon: "\u{1F528}", color: "#8B8B8B" },
  { id: "fasteners", label: "Fasteners", icon: "\u{1F529}", color: "#A0A0A0" },
  { id: "outdoor", label: "Outdoor", icon: "\u{1F33F}", color: "#6DAE6D" },
];

export const CONTAINER_TYPES = [
  { id: "bag", label: "Tool Bag", icon: "\u{1F392}" },
  { id: "bin", label: "Storage Bin", icon: "\u{1F4E6}" },
  { id: "cabinet", label: "Cabinet", icon: "\u{1F5C4}\uFE0F" },
  { id: "drawer", label: "Drawer", icon: "\u{1F5C3}\uFE0F" },
  { id: "shelf", label: "Shelf", icon: "\u{1F4DA}" },
];
